export default __webpack_public_path__ + "static/media/icon_tracking_pixels.e4555854.svg";